import {createAction, props} from '@ngrx/store';
import {ParsedRecordExport} from '@spout/web-global/models';

export const saveRecordedAudio = createAction(
  '[DeviceStorage] Save Wav File To Disk',

  // TODO save to affects, sync, disk etc
  props<ParsedRecordExport>()
);
